import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import styled, { css } from 'styled-components';

interface ScreenContainerProps {
  active: boolean;
}

export const ScreenContainer = styled.div<ScreenContainerProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 300ms ease-in-out;
  opacity: 0;
  border-radius: 14px;
  overflow: hidden;
  z-index: 2;

  .desktop-image {
    display: block;
  }

  .mobile-image,
  .mobile-video-player {
    display: none;
    max-width: 317px;
    margin: 0 auto;
  }

  .gatsby-image-wrapper,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${(props) =>
    !props.active
      ? ''
      : css`
          opacity: 1;
        `}

  ${applyStylesToMobileExperience(css`
    .desktop-image {
      display: none;
    }

    .mobile-image {
      display: block;
    }

    .desktop-video-player {
      display: none;
    }
    .mobile-video-player {
      display: block;
    }
  `)}
`;

export const ScreenSwapContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;

  /* Use the first screen as relative to set container size */
  ${ScreenContainer}:first-child {
    position: relative;
  }

  ${applyStylesToMobileExperience(css`
    width: 82%;
  `)}
`;

export const ArrowsContainer = styled.div`
  display: none;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;

  ${applyStylesToMobileExperience(css`
    display: block;
  `)}
`;

const arrowStyle = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
  width: 40px;
  height: 40px;
`;

export const LeftArrow = styled.div`
  ${arrowStyle}
  left: -50px;
  transform: translateY(-50%) rotate(180deg);
`;

export const RightArrow = styled.div`
  ${arrowStyle}
  right: -50px;
`;
